<template>
  <div v-loading="loading" class="main-frame">
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-form :inline="true" @submit.native.prevent>
            <!-- <el-form-item label="状态:">
                <el-select
                  v-model="page_status"
                  clearable
                  placeholder="请选择"
                  loading-text="加载中..."
                >
                  <el-option
                    v-for="item in status_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>-->
            <el-form-item label="开始时间:">
              <el-date-picker
                v-model="begin_time"
                type="datetime"
                placeholder="选择日期时间"
                default-time="12:00:00"
                align="center"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间:">
              <el-date-picker
                v-model="end_time"
                type="datetime"
                placeholder="选择日期时间"
                default-time="12:00:00"
                align="center"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="上传记录id:">
              <el-input
                v-model="upload_log_id"
                clearable
                size="medium"
                placeholder="请输入上传记录id"
              ></el-input>
            </el-form-item>
            <el-form-item label="查询码:">
              <el-input
                v-model="query_code"
                clearable
                size="medium"
                placeholder="请输入查询码"
              ></el-input>
            </el-form-item>
            <el-button
              class="top-button"
              size="medium"
              type="primary"
              round
              @click="getModelList"
              >过滤
            </el-button>
          </el-form>
        </div>
      </el-header>
      <el-main>
        <el-table
          :data="model_list"
          style="width: 100%"
          :cell-style="$common.tableStyle"
          :header-cell-style="$common.tableStyle"
          border
          default-expand-all
        >
          <el-table-column label="#" width="80" align="center">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.$index + 1 }}</p>
            </template>
          </el-table-column>
          <el-table-column label="上传记录ID" align="center" width="250">
            <template slot-scope="scope">
              <a
                :href="'/code-upload-detail??id=' + scope.row.upload_log_id"
                class="jump_button"
              >
                {{ scope.row.upload_log_id }}
              </a>
            </template>
          </el-table-column>
          <el-table-column label="查询码" align="center">
            <template slot-scope="scope">
              <p style="font-weight: bold">
                {{ scope.row.query_code }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="失败原因" align="center">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.row.err }}</p>
            </template>
          </el-table-column>
          <el-table-column label="更新时间" align="center">
            <template slot-scope="scope">
              <p style="font-weight: bold">
                {{ $common.formatTimesToTime(scope.row.updated_at) }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="失败时间" align="center">
            <template slot-scope="scope">
              <p style="font-weight: bold">
                {{ $common.formatTimesToTime(scope.row.created_at) }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <el-tag
                style="font-weight: bold"
                :type="
                  status_select_list[scope.row.status - 1]
                    ? status_select_list[scope.row.status - 1].tag
                    : ''
                "
                effect="dark"
                >{{
                  status_select_list[scope.row.status - 1]
                    ? status_select_list[scope.row.status - 1].name
                    : "-"
                }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                style="color: #03aef9"
                @click="checkModelDetail(scope.row)"
                type="text"
                >详情
              </el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-main>
      <el-footer class="footer-info">
        <el-pagination
          style="margin-top: 15px"
          background
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[20, 50, 100, 150]"
          :page-size="page_size"
          @size-change="handleSizeChange"
          :pager-count="9"
          :total="page_total"
          :current-page="page_number"
          @current-change="currentChangeOnclick"
        ></el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "CodeUploadListView",
  data() {
    return {
      loading: false,
      search_key: "",
      page_status: 0,
      page_total: 0,
      page_size: 20,
      page_number: 1,
      upload_log_id: "",
      query_code: "",
      model_list: [],
      begin_time: "",
      end_time: "",
      status_list: [
        {
          id: 0,
          name: "所有",
          tag: "primary",
        },
        {
          id: 1,
          name: "正常",
          tag: "primary",
        },
        {
          id: 2,
          name: "锁定",
          tag: "success",
        },
        {
          id: 3,
          name: "黑名单",
          tag: "danger",
        },
      ],
      status_select_list: [
        {
          id: 1,
          name: "已处理",
          tag: "success",
        },
        {
          id: 2,
          name: "未处理",
          tag: "primary",
        },
      ],
    };
  },
  created() {
    this.getModelList();
  },
  methods: {
    getModelList() {
      let _me = this;
      let params = {
        // key: _me.search_key,
        // status: _me.page_status,
        page_size: _me.page_size,
        page_number: _me.page_number,
        sort_fields: "",
        upload_log_id: _me.upload_log_id,
        query_code: _me.query_code,
        begin_time: _me.$common.formatTimestampLongZone(_me.begin_time),
        end_time: _me.$common.formatTimestampLongZone(_me.end_time),
      };
      _me.loading = true;
      _me.$common
        .httpPost("/api/anti/fake/admin/external/upload/err/log/find/list", params)
        .then((res) => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.model_list = res.data.array === undefined ? [] : res.data.array;
            _me.page_total = res.data.total;
          } else {
            _me.$message({
              message: res.message || "获取数据失败",
              type: "error",
            });
          }
        })
        .catch((err) => {
          _me.loading = false;
          _me.$message({
            message: err.message || "获取数据失败",
            type: "error",
          });
        });
    },
    checkModelDetail(model) {
      let path =
        model && model.id ? "code-upload-detail?id=" + model.id : "code-upload-detail";
      this.$router.push(path);
    },
    currentChangeOnclick(number) {
      this.page_number = number;
      this.getModelList();
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.getModelList();
    },
  },
};
</script>

<style scoped></style>
